import * as React from 'react';
import VK, {Comments} from "react-vk";
import * as comment from "./style.module.scss";
export const Comment = () => {
  return (
    <section className={comment.comment}>
      <div className="container">
        <VK apiId={4999718}>
          <Comments/>
        </VK>
      </div>
    </section>
  )
};
